import React, { Component } from "react";
import '../App.css';
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import 'bootstrap/dist/css/bootstrap.min.css';

import { connect } from 'react-redux'
import { UpdateChangeProgress } from "../Store/progress"
import { getCurrentState } from '../Store'
import LoanOverview from "./LoanOverview";
import LoanV2 from "./LoanV2";
import { fetchSelectedProductV2, loanIdFromPath } from "./LoanV2/api";
import "./LoanSummary.css";

const mapStateToProps = (state) => {
    return {
        application: state.application,
        progress: state.progress,
        borrower: state.borrower
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateChangeProgress: (step, stage) => {
        dispatch(UpdateChangeProgress(step, stage))
    },
});

class LoanSummary extends Component {
    returnTrue = () => true

    constructor(props) {
        super(props);
        this.form = React.createRef();
        this.wizard = []
        this.state = {
            currentIndex: 0,
            currentPane: null,
            hiddenPrevious: true,
            hiddenNext: true,
            validated: false,
            selectionReady: false,
            selectionLoading: true,
            selectionError: "",
            hasSelection: false,
            loanId: loanIdFromPath(),
        }
    }

    buildWizard = (hasSelection) => {
        const wizard = []
        let r = React.createRef()
        wizard.push([<LoanOverview ref={r} />, this.returnTrue, r])
        if (hasSelection) {
            r = React.createRef()
            // LoanV2 is last step; Fees / closing-cost page is not shown in V2.
            wizard.push([
                <LoanV2 loanId={this.state.loanId} />,
                this.returnTrue,
                r,
            ])
        }
        return wizard
    }

    applyWizard = (hasSelection, preferIndex) => {
        this.wizard = this.buildWizard(hasSelection)
        let index = 0
        if (preferIndex != null) {
            index = Math.min(this.wizard.length - 1, preferIndex)
        } else if (this.props.progress?.stage === "loinput") {
            index = Math.min(
                this.wizard.length - 1,
                parseInt(this.props.progress?.loinput?.step, 10) || 0
            )
        }
        this.setState({
            hasSelection,
            selectionReady: true,
            selectionLoading: false,
            selectionError: "",
            currentIndex: index,
            currentPane: this.wizard[index][0],
            hiddenPrevious: index === 0,
            hiddenNext: index === this.wizard.length - 1,
        })
        this.props.updateChangeProgress(index, "loinput")
    }

    loadSelectionGate = () => {
        const loanId = loanIdFromPath()
        this.setState({
            loanId,
            selectionLoading: true,
            selectionError: "",
        })
        if (!loanId) {
            this.applyWizard(false, 0)
            this.setState({
                selectionLoading: false,
                selectionError: "missing loan id",
            })
            return
        }
        const token = sessionStorage.getItem("ZeitroA")
        fetchSelectedProductV2(loanId, token)
            .then((js) => {
                this.applyWizard(!!js.hasSelection)
            })
            .catch((err) => {
                this.applyWizard(false, 0)
                this.setState({
                    selectionError: err.message || "Failed to check selected product",
                })
            })
    }

    oninit = (callback) => {
        this.submit = callback
    }
    previous = () => {
        let newindex = Math.max(this.state.currentIndex - 1, 0);
        for (; ;) {
            let [, check] = this.wizard[newindex]
            if (check())
                break;
            newindex -= 1
            if (newindex === 0)
                break;
        }

        this.setState({ currentIndex: newindex });
        this.setState({ validated: false });
        this.setState({ currentPane: this.wizard[newindex][0], hiddenNext: (newindex === this.wizard.length - 1) });
        this.props.updateChangeProgress(newindex, "loinput")
        if (newindex === 0)
            this.setState({ hiddenPrevious: true });
        getCurrentState({application: this.props.application, borrower: this.props.borrower}, sessionStorage.getItem("originalstate"))
    }
    next = () => {
        let newindex = Math.min(this.state.currentIndex + 1, this.wizard.length - 1);
        for (; ;) {
            let [, check] = this.wizard[newindex]
            if (check())
                break;
            newindex += 1

            if (newindex === this.wizard.length - 1)
                break;
        }
        this.setState({ currentIndex: newindex, hiddenNext: (newindex === this.wizard.length - 1) });
        this.setState({ currentPane: this.wizard[newindex][0] });

        this.props.updateChangeProgress(newindex, "loinput")

        if (newindex !== 0)
            this.setState({ hiddenPrevious: false });

        getCurrentState({application: this.props.application, borrower: this.props.borrower}, sessionStorage.getItem("originalstate"))
    }
    isValidated() {
        if (!this.form.current.reportValidity()) {
            this.setState({ validated: true })
            return false
        };
        return true;
    }
    handleSubmit = (event) => {
        if (this.form.current.reportValidity() === false) {
            event.preventDefault();
            this.setState({ validated: true })
            return false
        }

        let child = this.wizard[this.state.currentIndex][2].current
        if (child && child.handleSubmit) {
            if (!child.handleSubmit(event)) {
                event.preventDefault();
                event.stopPropagation();
                this.setState({ validated: true })
                return false;
            }
        }

        event.preventDefault();
        this.setState({ validated: false })
        event.stopPropagation();
        this.next()
        return true
    }
    rollback = () => {
        this.setState({ currentIndex: 0 });
        this.setState({ currentPane: this.wizard[0][0], validated: false, hiddenPrevious: true, hiddenNext: (this.wizard.length - 1 === 0) });
        this.props.updateChangeProgress(0, "loinput")
        getCurrentState({application: this.props.application, borrower: this.props.borrower}, sessionStorage.getItem("originalstate"))
    }
    componentDidMount() {
        this.loadSelectionGate()
    }
    render() {
        if (this.state.selectionLoading || !this.state.selectionReady) {
            return (
                <div className="loan-summary-shell loan-summary-shell-loading">
                    Loading loan summary…
                </div>
            )
        }
        return (
                <div className="loan-summary-shell blackish">
                    {this.state.selectionError ? (
                        <div className="text-warning mb-2">{this.state.selectionError}</div>
                    ) : null}
                    <Form ref={this.form} id="personalform" noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
                        <div className="loan-summary-pane">
                            {this.state.currentPane}
                        </div>
                        <div className="loan-summary-nav">
                            <Button
                                variant="primary"
                                hidden={this.state.currentIndex === 0}
                                onClick={this.rollback}
                            >
                                &lt;&lt;
                            </Button>
                            <Button
                                variant="primary"
                                hidden={this.state.hiddenPrevious}
                                onClick={this.previous}
                            >
                                Previous
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                hidden={this.state.hiddenNext}
                            >
                                Next
                            </Button>
                        </div>
                    </Form>
                </div>

        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoanSummary)
